@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

.package-content-description-container {
  display: flex;
  span {
    justify-content: center;
    align-items: center;
    padding-left: @space-4;
    display: inline-flex;
    .package-content-description-info-icon {
      color: var(--default--icon--fill-color--1);
      width: 12px;
      height: 12px;
    }
  }
}
